import React from "react";

import connect from "../i18n/connect";
import {
  fetchSelectedOfferRoutine,
  finalizePaymentRoutine
} from "../redux/modules/payment";
import {
  getPaymentFormLoading,
  getSelectedOffer,
  getSelectedOfferError,
  getSelectedOfferLoading
} from "../redux/modules/payment/selector";
import { fetchOffersRoutine } from "../redux/modules/plans";
import { getOffers } from "../redux/modules/plans/selector";

export default function withPaymentForm(WrappedComponent) {
  const mapStateToProps = state => ({
    selectedOffer: getSelectedOffer(state),
    selectedOfferLoading: getSelectedOfferLoading(state),
    selectedOfferError: getSelectedOfferError(state),
    paymentFormLoading: getPaymentFormLoading(state),
    offers: getOffers(state)
  });

  const mapDispatchToProps = {
    finalizePayment: finalizePaymentRoutine,
    fetchSelectedOffer: fetchSelectedOfferRoutine,
    fetchOffers: fetchOffersRoutine
  };

  @connect(mapStateToProps, mapDispatchToProps)
  class WithPaymentForm extends React.Component {
    componentDidMount() {
      const {
        fetchSelectedOffer,
        fetchOffers,
        match: {
          params: { offerId }
        }
      } = this.props;

      fetchSelectedOffer({ offerId });
      fetchOffers();
    }

    componentDidUpdate(prevProps) {
      const prevId = prevProps.match?.params?.offerId;
      const nextId = this.props.match?.params?.offerId;

      if (prevId !== nextId && nextId) {
        this.props.fetchSelectedOffer({ offerId: nextId });
        this.props.fetchOffers();
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithPaymentForm;
}
